import { connect } from 'react-redux';
import { removeLocationFromOrder } from '../../../redux/actions/Orders';

const mapStateToProps = state => ({
  urls: state.mainreducer.urls,
  selectedLocations: state.mainreducer.selectedLocations,
  logoPath: state.mainreducer.logoPath,
  privacyPage: state.mainreducer.privacyPage,
  siteName: state.mainreducer.siteName,
});

const mapDispatchToProps = dispatch => ({
  removeLocationFromOrder(id) {
    dispatch(removeLocationFromOrder(id));
  },
});

export default Header => connect(mapStateToProps, mapDispatchToProps)(Header);
